import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface ResetCompanyParams {
  id: string;
  companyName: string;
}

export const useResetCompanyMutation = () => {
  return useMutation({
    mutationFn: ({ id, companyName }: ResetCompanyParams) =>
      fetchClient.POST(endpoints.resetCompany, {
        params: { path: { id } },
        body: { companyName },
      }),
    onSettled: () => {
      invalidateQuery(companiesQueryKeys.list())();
    },
  });
};
